import api from './api';

class FacultyService {
  /**
   * Get paginated list of faculties
   * @param {number} page - Page number (0-based)
   * @param {number} size - Page size
   * @param {string} search - Search query
   * @param {number} campusId - Filter by campus
   * @returns {Promise} API response
   */
  async getFaculties(page = 0, size = 10, search = '', campusId = null) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });
      
      if (search?.trim()) {
        params.append('search', search.trim());
      }
      
      if (campusId) {
        params.append('campusId', campusId.toString());
      }

      const response = await api.get(`/admin/faculties?${params}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get faculty by ID
   * @param {number} id - Faculty ID
   * @returns {Promise} API response
   */
  async getFaculty(id) {
    try {
      const response = await api.get(`/admin/faculties/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Create new faculty
   * @param {Object} data - Faculty data
   * @returns {Promise} API response
   */
  async createFaculty(data) {
    try {
      const response = await api.post('/admin/faculties', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Update faculty
   * @param {number} id - Faculty ID
   * @param {Object} data - Faculty data
   * @returns {Promise} API response
   */
  async updateFaculty(id, data) {
    try {
      const response = await api.put(`/admin/faculties/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Delete faculty
   * @param {number} id - Faculty ID
   * @returns {Promise} API response
   */
  async deleteFaculty(id) {
    try {
      const response = await api.delete(`/admin/faculties/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

const facultyService = new FacultyService();
export default facultyService;